// extracted by mini-css-extract-plugin
module.exports = {"share__header":"social-media-share_share__header__ql0PH","share__buttons":"social-media-share_share__buttons__dee_H"};